/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================
   HushTug UTM Attribution Tracking (test implementation)
   - first attribution: saved once, never overwritten
   - latest attribution: updated on every UTM visit
   - storage: localStorage + Shopify cart attributes
   ============================================================ */
(function () {
  'use strict';

  var UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var HT_FIELDS  = ['ht_intent', 'ht_segment', 'ht_products'];
  var FIRST_KEY  = 'ht_first_attribution';
  var LATEST_KEY = 'ht_latest_attribution';

  function getAttribution() {
    var params = new URLSearchParams(window.location.search);
    var hasUtm = UTM_FIELDS.concat(HT_FIELDS).some(function (k) { return params.get(k); });
    if (!hasUtm) return null;

    var data = {};
    UTM_FIELDS.forEach(function (k) { data[k] = params.get(k) || ''; });
    HT_FIELDS.forEach(function (k) { data[k] = params.get(k) || ''; });
    data.landing_page = window.location.pathname + window.location.search;
    data.referrer     = document.referrer || '';
    data.visit_at     = new Date().toISOString();
    return data;
  }

  function readStorage(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
  }

  function writeStorage(key, data) {
    try { localStorage.setItem(key, JSON.stringify(data)); } catch (e) {}
  }

  function sendCartAttributes(first, latest) {
    var attrs = {};
    var ALL_FIELDS = UTM_FIELDS.concat(['landing_page', 'referrer', 'visit_at']);
    ['first', 'latest'].forEach(function (type) {
      var data = type === 'first' ? first : latest;
      if (!data) return;
      ALL_FIELDS.forEach(function (field) {
        attrs['ht_' + type + '_' + field] = data[field] || '';
      });
      HT_FIELDS.forEach(function (field) {
        attrs['ht_' + type + '_' + field.replace(/^ht_/, '')] = data[field] || '';
      });
    });
    if (Object.keys(attrs).length === 0) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (res) {
      if (res.ok) console.log('[HT UTM] cart attributes sent:', attrs);
    }).catch(function () {});
  }

  function run() {
    var attribution = getAttribution();

    if (attribution) {
      // UTM visit: update latest, save first if not yet set
      writeStorage(LATEST_KEY, attribution);
      console.log('[HT UTM] latest saved:', attribution);

      var first = readStorage(FIRST_KEY);
      if (!first) {
        writeStorage(FIRST_KEY, attribution);
        first = attribution;
        console.log('[HT UTM] first saved:', attribution);
      }
      sendCartAttributes(first, attribution);
    } else {
      // Non-UTM visit: do not update attribution, but re-send existing data to cart
      var first = readStorage(FIRST_KEY);
      var latest = readStorage(LATEST_KEY);
      if (first || latest) {
        console.log('[HT UTM] re-sending existing attributions to cart');
        sendCartAttributes(first, latest);
      }
    }
  }

  run();
})();

// PC での商品ギャラリー動画自動再生（視認エリア進入時）
(function () {
  function setupIntersectionAutoplay() {
    var videoMedia = document.querySelector('product-gallery video-media[type="video"]');
    if (!videoMedia) return false;
    var video = videoMedia.querySelector('video');
    if (!video) return false;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var poster = videoMedia.querySelector('img');
          if (poster) poster.style.display = 'none';
          if (videoMedia.shadowRoot) {
            var btn = videoMedia.shadowRoot.querySelector('[part="play-button"]');
            if (btn) btn.style.display = 'none';
          }
          video.style.display = 'block';
          video.style.opacity = '1';
          video.muted = true;
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 });

    observer.observe(videoMedia);
    return true;
  }

  customElements.whenDefined('video-media').then(function () {
    if (!setupIntersectionAutoplay()) {
      var gallery = document.querySelector('product-gallery');
      if (!gallery) return;
      var mo = new MutationObserver(function () {
        if (setupIntersectionAutoplay()) mo.disconnect();
      });
      mo.observe(gallery, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 10000);
    }
  });
})();